<template>
  <div class="row">
    <div
      class="text-secondary font-weight-bolder text-center col"
      v-if="noData"
    >
      No data.
    </div>

    <div
      v-for="resource in resources"
      :key="resource.id"
      class="col-12 col-md-6 col-lg-4 pr-md-1 pr-lg-4 pb-4"
    >
      <resource-card :resource="resource"> </resource-card>
    </div>

    <div class="col-12 d-flex justify-content-center">
      <div class="spinner-border text-secondary" role="status" v-if="loading">
        <span class="sr-only">Loading...</span>
      </div>
      <div
        class="btn btn-outline-dark font-weight-bolder margin-auto"
        v-if="hasMore && !loading"
        @click="loadMore"
      >
        Load More Results...
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['type'],

  data() {
    return {
      hasMore: false,
      loading: false,
      currentPage: 1,
      resources: [],
    };
  },

  computed: {
    noData() {
      return !this.resources.length;
    },
  },

  methods: {
    loadMore() {
      this.currentPage++;
      this.fetchResources();
    },

    async fetchResources() {
      this.loading = true;
      try {
        // Load Data.
        const {
          status,
          data: {
            data: { data, last_page },
          },
        } = await axios.get(`/resource?type=${this.type}&page=` + this.currentPage);
        this.resources = this.resources.concat(...data);
        this.hasMore = this.currentPage < last_page;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
  },

  mounted() {
    this.fetchResources();
  },
};
</script>


<style lang="scss" scoped>
</style>
